import React, { useState, useEffect } from "react";
import { getAllImages, getAppParams } from "../../api/api";
import "toastr/build/toastr.min.css";
import "../colors/colors.css";
import Select from "react-select";
import { UserEpg, UserLang } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";
import Button from "react-bootstrap/Button";
import LabelImage from "../cards/image";
import MyVerticallyCenteredModal from "../imgUpload/modal";

const EPGDetail = (props) => {
  const lan = UserLang.useState((s) => s.lan);
  const [characters, updateCharacters] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [allImage, setallImage] = useState([]);
  const [hold, setHold] = useState([]);
  const { id } = props.location.state;
  const { array } = props.location.state;
  const { url } = props.location.state;

  useEffect(() => {
    /* eslint-disable no-unused-vars */
    const getImage = async () => {
      try {
        const appl = await getAllImages(100, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));

        setallImage(opt);
      } catch (error) {}
    };

    const getDetails = () => {
      if (props.listData[0]) {
        const opt = props.listData.map((item, index) => ({
          description: item.description,
          title: item.title,
          image: item.image,
          Year: item.Year,
          Director: item.Director,
          Actors: item.Actors,
          Genre: item.Genre,
          Rated: item.Rated,
          Released: item.Released,
          Language: item.Language,
          since: item.since,
          till: item.till,
          order: index + 1,
        }));

        //  setId(opt);
        updateCharacters(opt);
      }
    };
    if (props.listData) getDetails();
    getImage();
    /* eslint-disable no-unused-vars */
    // eslint-disable-next-line
  }, [props.data, props.listData, props.list]);
  const handleDetails = (evt) => {
    const value = evt.target.value;
    setHold({
      ...hold,
      [evt.target.name]: value,
    });
  };

  const filterOption = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const handleDetail = (value, evt) => {
    setHold({
      ...hold,
      image: value.key,
    });
  };

  const Save = () => {
    const opt = {
      description: hold.description ? hold.description : id.description,
      title: hold.title ? hold.title : id.title,
      image: hold.image ? hold.image : id.image,
      Year: hold.Year ? hold.Year : id.Year,
      Director: hold.Director ? hold.Director : id.Director,
      Actors: hold.Actors ? hold.Actors : id.Actors,
      Genre: hold.Genre ? hold.Genre : id.Genre,
      Rated: hold.Rated ? hold.Rated : id.Rated,
      Released: hold.Released ? hold.Released : id.Released,
      Language: hold.Language ? hold.Language : id.Language,
      since: hold.since ? hold.since : id.since,
      till: hold.till ? hold.till : id.till,
      order: id.order,
    };

    reorderArray(opt);
  };

  const reorderArray = (items) => {
    updateCharacters(items);
    UserEpg.update((s) => {
      s.array = items;
    });

    props.history.push("/epg/" + url, { array: items });
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h3
                  className={
                    lan === "rtl"
                      ? "card-title float-right"
                      : "card-title float-left"
                  }
                >
                  Media Details
                </h3>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                <div className="row mb-2 mt-2"></div>
                <div className="row mb-2 mt-2"></div>
                <div className="row">
                  <div className="col-sm-6">
                    {/* text input */}
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                        Description &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
                      </label>
                      <textarea
                        name="description"
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        className="form-control inside-form"
                        placeholder="Description ..."
                        defaultValue={id.description}
                        onChange={handleDetails}
                        autoComplete="off"
                      ></textarea>{" "}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                        Title &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="title"
                        className="form-control inside-form"
                        placeholder="Title ..."
                        defaultValue={id.title}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    {/* text input */}
                    <div className="form-group">
                      <div className="row">
                        {lan === "rtl" && (
                          <div className="col-md-4">
                            <Button
                              variant="light"
                              onClick={() => setModalShow(true)}
                              style={{
                                width: "100px",
                                marginTop: "8px",
                                height: "40px",
                              }}
                            >
                              Upload
                            </Button>
                          </div>
                        )}
                        <div
                          className="col-md-8"
                          dir={lan === "rtl" ? "rtl" : "ltr"}
                        >
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {!(lan==="rtl")&&<ToolTip 
            info={"Banner image used in Banner field"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Image
                            {/* &nbsp;{(     lan==="rtl")&&<ToolTip 
            info={"Banner image used in Banner field"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <Select
                            name="image"
                            className={
                              lan === "rtl"
                                ? "form-control inside-select float-right"
                                : "form-control inside-select float-left"
                            }
                            filterOption={filterOption}
                            options={allImage}
                            onChange={(value, event) =>
                              handleDetail(value, event)
                            }
                          ></Select>
                          <div
                            className="row"
                            style={{
                              marginTop: "100px",
                              backgroundColor: "#f2f2f2",
                            }}
                          >
                            <div
                              className="col-md-12"
                              style={{ marginTop: "20px" }}
                            >
                              <LabelImage
                                url={
                                  getAppParams() +
                                  (hold.image ? hold.image : id.image)
                                }
                              ></LabelImage>
                            </div>
                          </div>
                        </div>
                        {!(lan === "rtl") && (
                          <div className="col-md-4">
                            <Button
                              variant="light"
                              onClick={() => setModalShow(true)}
                              style={{
                                width: "100px",
                                marginTop: "8px",
                                height: "40px",
                              }}
                            >
                              Upload
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                        Year &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="number"
                        name="Year"
                        className="form-control inside-form"
                        placeholder="Year ..."
                        defaultValue={id.Year}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    {/* text input */}
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                        Director
                        {/* &nbsp;
            {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="Director"
                        className="form-control inside-form"
                        placeholder="Director ..."
                        defaultValue={id.Director}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                        Actors &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="Actors"
                        className="form-control inside-form"
                        placeholder="Actors ..."
                        defaultValue={id.Actors}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    {/* text input */}
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                        Genre &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="Genre"
                        className="form-control inside-form"
                        placeholder="Genre ..."
                        defaultValue={id.Genre}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                        Rated &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="Rated"
                        className="form-control inside-form"
                        placeholder="Rated ..."
                        defaultValue={id.Rated}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    {/* text input */}
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                        Released &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="Released"
                        className="form-control inside-form"
                        placeholder="Released ..."
                        defaultValue={id.Released}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                        Language &nbsp;
                        {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="Language"
                        className="form-control inside-form"
                        placeholder="Language ..."
                        defaultValue={id.Language}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    {/* text input */}
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={"Name used to identify this element on CMS"}
                          />
                        )}
                        &nbsp; Since &nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={"Name used to identify this element on CMS"}
                          />
                        )}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="since"
                        className="form-control inside-form"
                        placeholder="2022-01-01"
                        defaultValue={id.since}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip info={"Title name for the element"} />
                        )}
                        &nbsp; Till &nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={"Title name for the element"}
                            place={"right"}
                          />
                        )}
                      </label>
                      <input
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                        type="text"
                        name="till"
                        className="form-control inside-form"
                        placeholder="2022-01-01"
                        defaultValue={id.till}
                        onChange={handleDetails}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div
                    className={
                      lan === "rtl"
                        ? "float-left btn-group btn-group-md"
                        : "float-right btn-group btn-group-md"
                    }
                    role="group"
                  >
                    <button
                      onClick={Save}
                      className="btn btn-light btn-block"
                      style={{ width: "100px", marginRight: "6px" }}
                    >
                      Draft
                    </button>
                  </div>
                </div>
              </div>
              <div className="row mb-2 mt-2"></div>
              <div className="row mb-2 mt-2"></div>

              <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                allimage={allImage}
              />

              {/* /.card-body */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EPGDetail;
